import { useEffect } from "react";

type Props = {
	contentRef: React.RefObject<HTMLElement | null>;
	setIsPopover: React.Dispatch<React.SetStateAction<boolean>>;
	open: boolean | undefined;
};

export function useHideOnClickOutside(props: Props) {
	const { contentRef, setIsPopover, open } = props;

	useEffect(() => {
		if (!open) return;

		const handleOutsideInteraction = (event: MouseEvent | KeyboardEvent) => {
			const target = event.target as Node;
			if (!target) return;

			if (event instanceof KeyboardEvent && event.key === "Escape") {
				setIsPopover(false);
				return;
			}

			const contentElement = contentRef.current as HTMLElement | null;

			const isOutside = Boolean(
				contentElement && !contentElement.contains(target),
			);

			if (isOutside) {
				setIsPopover(false);
			}
		};

		document.addEventListener("mousedown", handleOutsideInteraction);
		document.addEventListener("keydown", handleOutsideInteraction);

		return () => {
			document.removeEventListener("mousedown", handleOutsideInteraction);
			document.removeEventListener("keydown", handleOutsideInteraction);
		};
	}, [open, setIsPopover, contentRef]);
}
